module.exports = __webpack_public_path__ + "assets/img/email.da5f8873.svg";